import { Set, Get } from "../../../../../Request";
import { useState } from "react";
export const useContactUs = () => {
  const [loading, setLoading] = useState({
    list: true,
  });
  const [data, setData] = useState();
  const [modal, setModal] = useState({ visible: false, data: {} });

  const getData = async data => {
    setLoading({ list: true });
    Get({
      url: "/contactus/get",
      data: data,
    }).then(res => {
      setLoading({ list: false });
      setData(res);
    });
  };
  const searchHandler = data => {
    setLoading({ list: true });
    getData({ fullname: data }).then(data => {
      setLoading({ list: false });
    });
  };

  return {
    getData,
    data,
    loading,
    searchHandler,
    modal,
    setModal,
  };
};
